import { render, staticRenderFns } from "./AdministrationHeader.vue?vue&type=template&id=6392ce7e&scoped=true"
import script from "./AdministrationHeader.vue?vue&type=script&lang=ts"
export * from "./AdministrationHeader.vue?vue&type=script&lang=ts"
import style0 from "./AdministrationHeader.vue?vue&type=style&index=0&id=6392ce7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6392ce7e",
  null
  
)

export default component.exports